import { FC, ReactNode, KeyboardEvent } from 'react';
import { IconName } from 'src/components';
import isIconName from 'src/components/Button';
import Icon from '../Icon';
import * as S from './styles';

export const IconButton: FC<{
  disabled?: boolean;
  handleClick: () => void;
  ariaLabel?: string;
  icon?: IconName | ReactNode;
  text?: string;
  className?: string;
  inverseColors?: boolean;
  pressed?: boolean;
  children?: string;
}> = ({
  disabled = false,
  handleClick,
  ariaLabel,
  icon,
  text,
  className,
  inverseColors = false,
  pressed = false,
  children,
}) => {
  const onClick = () => {
    if (disabled) return;
    handleClick();
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <S.Wrapper $disabled={disabled} onClick={onClick}>
      <S.ButtonWrapper
        onClick={() => !text && onClick}
        onKeyDown={handleKeyDown}
        aria-label={ariaLabel}
        aria-disabled={disabled}
        aria-pressed={pressed}
        disabled={disabled}
        className={className}
        $disabled={disabled}
        $inverseColors={inverseColors}
        $pressed={pressed}
        $textInside={!!children}
      >
        {isIconName(icon) ? <Icon name={icon} /> : icon}
        {children}
      </S.ButtonWrapper>
      {text}
    </S.Wrapper>
  );
};
